var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.src),expression:"src"}],ref:"grafana",attrs:{"src":_vm.src,"width":"100%","height":"100%","frameborder":"0","id":"frame"}})}
var staticRenderFns = []

export { render, staticRenderFns }